import { lazy, Suspense } from "react";
import BlaBlaHead from "../blabla/BlaBlaHead";
import BlaBlaMission from "../blabla/BlaBlaMission";

const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const BlaBlaAction = lazy(() => import("../blabla/BlaBlaAction"));
const BlaBlaAllin = lazy(() => import("../blabla/BlaBlaAllin"));
const BlaBlaBusiness = lazy(() => import("../blabla/BlaBlaBusiness"));
const BlaBlaFeature = lazy(() => import("../blabla/BlaBlaFeature"));
const BlaBlaMinimum = lazy(() => import("../blabla/BlaBlaMinimum"));
const BlaBlaTech = lazy(() => import("../blabla/BlaBlaTech"));
const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));

const HeadData = {
  title: "Launch a BlaBlaCar-Style Carpooling App for Italy!",
  description: "Our carpooling app development services provide state-of-the-art features, modern design, and powerful tools to help digitize and grow your shared mobility business across Italy and the broader European region.",
  image: "/assets/home/blabla-banner.webp",
  backImage: "/assets/home/blabla-banner-back.webp",
  btn: "Schedule A Demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "blabla Clone App italy",
        slug: ""
      },
    ]
  }
};

const missionData = {
  mission: "Our Mission",
  titlePart1: "We specialize",
  titlePart2: "in delivering scalable mobility solutions",
  titlePart3: "tailored for transport operators worldwide.",
  description: "With over five years of hands-on experience navigating Europe’s busiest routes, we’ve engineered a reliable platform powered by operational expertise and customized marketing strategies. From our early days as a traditional mobility operator in 2020 to becoming a top mobility technology provider by 2025, we empower transport businesses to stay autonomous and thrive in today’s rapidly changing shared mobility landscape.",
}

const businessData = {
  titlePart1: "Versatile ",
  titlePart2: "Carpooling Solutions",
  titlePart3: "for All Types of Shared Mobility Models",
  description: "No matter what your shared mobility vision looks like, we provide the right technology to make it a reality.",
  boxes: [
    {
      image: "/assets/home/blabla-business-icon1.webp",
      heading: "Carpooling/Ridesharing Marketplace",
      description: "Easily build a smart, scalable carpooling platform like BlaBlaCar to connect everyday commuters, cut travel costs, reduce road congestion, and promote sustainable shared mobility throughout Italy and Europe.",
    },
    {
      image: "/assets/home/blabla-business-icon2.webp",
      heading: "Integrated Shared Mobility Platform",
      description: "Create a seamless, technology-driven shared mobility ecosystem that connects individuals traveling along similar routes. Provide a budget-friendly, and eco-conscious alternative for daily travel, minimizing traffic and emissions.",
    },
    {
      image: "/assets/home/blabla-business-icon3.webp",
      heading: "peer-to-peer Carpooling Sharing",
      description: "Introduce a reliable peer-to-peer carpooling app that links travelers heading in the same direction, delivering cost-efficient travel with features like real-time tracking, secure payments, reviews, and flexible rides.",
    },
  ]
}

const featureData = {
  titlePart1: "Features Of Our",
  titlePart2: "BlaBlaCar",
  titlePart3: "Inspired Carpooling Solution",
  description: "Our BlaBlaCar Clone app comes fully equipped with modern functionalities to ensure a smooth, secure, and user-friendly experience for both car owners and passengers:",
  boxes: [
    {
      image: "/assets/home/bla-feature-1.webp",
      heading: "Quick Sign-Up",
      description: "Swift registration through email or social media accounts.",
    },
    {
      image: "/assets/home/bla-feature-2.webp",
      heading: "Ride Discovery",
      description: "Search and reserve carpool rides to your chosen location.",
    },
    {
      image: "/assets/home/bla-feature-3.webp",
      heading: "Advanced Filters",
      description: "Filter ride options based on preferences, vehicle type, or route.",
    },
    {
      image: "/assets/home/bla-feature-4.webp",
      heading: "Intelligent Matching",
      description: "Smart suggestions instantly connect riders and car owners with compatible routes.",
    },
    {
      image: "/assets/home/bla-feature-5.webp",
      heading: "Fare & Time Estimates",
      description: "Clear fare, distance, and time estimates provided upfront.",
    },
    {
      image: "/assets/home/bla-feature-6.webp",
      heading: "In-App Alerts",
      description: "Real-time notifications for trip updates, confirmations, and important alerts.",
    },
    {
      image: "/assets/home/bla-feature-7.webp",
      heading: "Live GPS Tracking",
      description: "Real-time location tracking of both passengers and car owners with Google Maps integration.",
    },
    {
      image: "/assets/home/bla-feature-8.webp",
      heading: "Built-In Navigation",
      description: "Embedded navigation for efficient pick-ups, drop-offs, and optimal routes.",
    },
    {
      image: "/assets/home/bla-feature-9.webp",
      heading: "Review & Rating System",
      description: "User reviews for both passengers and car owners to maintain trust and quality.",
    },
    {
      image: "/assets/home/bla-feature-10.webp",
      heading: "Flexible Payment Options",
      description: "Integration with popular payment systems like PayPal, Stripe, and local alternatives.",
    },
    {
      image: "/assets/home/bla-feature-11.webp",
      heading: "In-App Calling via VoIP",
      description: "Secure voice calls through the app, protecting personal phone numbers.",
    },
    {
      image: "/assets/home/bla-feature-12.webp",
      heading: "Emergency SOS Function",
      description: "One-tap emergency alerts to instantly notify chosen contacts.",
    },
    {
      image: "/assets/home/bla-feature-13.webp",
      heading: "Invite Friends",
      description: "Easily invite friends and family to join the carpooling community.",
    },
    {
      image: "/assets/home/bla-feature-14.webp",
      heading: "Promo Codes",
      description: "Launch promotional campaigns to attract and retain users.",
    },
    {
      image: "/assets/home/bla-feature-15.webp",
      heading: "Ride Scheduling Flexibility",
      description: "Car owners can conveniently schedule, modify, or cancel rides to ensure flexibility for all users.",
    },
    {
      image: "/assets/home/bla-feature-16.webp",
      heading: "Multi-Language Interface",
      description: "Perfect for Italy’s multicultural and international user base.",
    },
  ]
}

const techData = {
  titlePart1: "Mobility Infotech Powering",
  titlePart2: "the Carpooling in Italy",
  description: "Mobility Infotech develops cutting-edge, intuitive carpooling apps with real-time features that boost operational efficiency and redefine shared mobility. We help transport businesses optimize their processes, reduce costs, and stay at the forefront of the smart mobility revolution.",
  image: "/assets/home/bla-tech-img.webp",
  boxes: [
    {
      image: "/assets/home/bla-tech-icon1.webp",
      heading: "Tailored to Your Business Goals",
      description: "Launch your carpooling platform with feature-rich apps and a customizable website – designed to be smart, scalable, and built for success in Italy’s and Europe’s mobility markets.",
    },
    {
      image: "/assets/home/bla-tech-icon2.webp",
      heading: "Technologically Advanced Development",
      description: "Customize your BlaBlaCar-style app to align with your business requirements. Whether you’re offering carpooling or peer-to-peer ridesharing, we help you choose the best features.",
    },
    {
      image: "/assets/home/bla-tech-icon3.webp",
      heading: "Simplified Ride Matching",
      description: "Our skilled development team ensures your carpooling platform operates seamlessly, scales efficiently, and maximizes your return on investment.",
    },
    {
      image: "/assets/home/bla-tech-icon4.webp",
      heading: "Advanced referral System",
      description: "Incorporate a modern referral program with multiple payment options for a smooth, flexible, and secure ride sharing experience.",
    }
  ]

}

const actionData = {
  imageBack: "/assets/home/bla-action-back.webp",
  title: "Don’t lose touch with your market",
  description: "Advance with confidence partner with Mobility Infotech for future-ready operations.",
  btn: "get in touch"
}

const allInData = {
  titlePart1: "All-in-One Features",
  titlePart2: "for Riders & Admins",

  feature1: {
    image: "/assets/home/bla-rider-main.webp",
    leftBoxes: [
      {
        title: "Effortless Registration",
        description: "Quick and secure sign-up process for passengers.",
        image: "/assets/home/bla-rider-1.webp",
      },
      {
        title: "Comprehensive Profile",
        description: "Complete passenger profiles to improve ride matching and enhance safety.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Accurate Location Details",
        description: "Provide precise location information for efficient pick-ups and route planning.",
        image: "/assets/home/bla-rider-3.webp",
      },
      {
        title: "Convenient Ride Selection",
        description: "Browse and select from available ride options with ease.",
        image: "/assets/home/bla-rider-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Fare Information",
        description: "Receive clear fare details upfront before confirming a booking.",
        image: "/assets/home/bla-rider-5.webp",
      },
      {
        title: "Live Tracking Features",
        description: "Monitor your ride's progress directly within the app.",
        image: "/assets/home/bla-rider-6.webp",
      },
      {
        title: "SOS Emergency Alerts",
        description: "Immediate alert system to notify emergency contacts for enhanced safety.",
        image: "/assets/home/bla-rider-7.webp",
      },
      {
        title: "Review & Rating System",
        description: "Transparent reviews to build trust and maintain a quality community.",
        image: "/assets/home/bla-rider-8.webp",
      },
    ],
  },

  feature2: {
    image: "/assets/home/bla-admin-main.webp",
    leftBoxes: [
      {
        title: "Role-Based Access",
        description: "Manage access to different sections of the admin panel by assigning role-based permissions.",
        image: "/assets/home/bla-admin-1.webp",
      },
      {
        title: "rider & car owner Profiles",
        description: "Manage and verify both passenger and car owner profiles to maintain high safety standards.",
        image: "/assets/home/bla-rider-2.webp",
      },
      {
        title: "Transaction Monitoring",
        description: "Track all financial activities and revenue streams with advanced real-time analytics.",
        image: "/assets/home/bla-admin-3.webp",
      },
      {
        title: "car owners Verification",
        description: "Allow car owners to verify their identity through official documentation to enhance platform security.",
        image: "/assets/home/bla-admin-4.webp",
      },
    ],
    rightBoxes: [
      {
        title: "Revenue Reporting",
        description: "Access comprehensive earnings reports to monitor business performance and revenue streams.",
        image: "/assets/home/bla-admin-5.webp",
      },
      {
        title: "Ride Summary",
        description: "Car owners can view detailed breakdowns of contributions received for shared rides.",
        image: "/assets/home/bla-admin-6.webp",
      },
      {
        title: "Community Reviews",
        description: "Supervise and moderate reviews for passengers and car owners to foster a respectful community.",
        image: "/assets/home/bla-rider-8.webp",
      },
      {
        title: "Platform Configuration",
        description: "Customize app settings, ride preferences, pricing structures, and more from the admin panel.",
        image: "/assets/home/bla-admin-8.webp",
      },
    ],
  },
}

const minimumData = {
  tagline: "Why quality matters more than price!",
  titlePart1: "Go Beyond",
  titlePart2: "the Basic MVP",
  description: "Launch with Mobility Infotech’s advanced BlaBlaCar Clone — a solution engineered for growth, dependability, and excellent user experience. Our carpooling solution surpasses basic functionality by delivering the scalability and performance essential for success in Italy’s competitive shared mobility industry.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Transparent Development Process",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "Core Features Available from Day One",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Updates with No Hidden Costs",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Elegant, User-Friendly Design",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Enterprise-Grade Support After Launch",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "Optimized for High Performance & Stability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const faqData = [
  {
    id: "0",
    question: "01. How customizable is the BlaBlaCar Clone app for my business?",
    answer: "Our app is fully adaptable to suit your business model, branding, and operational requirements. From the user interface to payment options, language support, and feature selection, everything can be tailored to your vision.",
  },
  {
    id: "1",
    question: "02. Can I offer the app in multiple languages for different regions?",
    answer: "Yes, our BlaBlaCar Clone is built with multi-language support, making it ideal for Italy’s diverse population and for seamless expansion into other European markets.",
  },
  {
    id: "2",
    question: "03. Is the app compliant with GDPR regulations?",
    answer: "Absolutely. We design our apps to comply fully with GDPR requirements, ensuring user data is handled securely and responsibly.",
  },
  {
    id: "3",
    question: "04. Does the app feature real-time ride tracking?",
    answer: "Yes, both car owners and passengers benefit from real-time location tracking for enhanced safety, transparency, and route optimization via Google Maps.",
  },
  {
    id: "4",
    question: "05. What payment options does the platform support?",
    answer: "We integrate popular payment gateways like PayPal and Stripe, along with Italy-specific or preferred payment methods tailored to your market.",
  },
  {
    id: "5",
    question: "06. How secure is communication between car owners and passengers?",
    answer: "The app offers VoIP-based in-app calling for private, secure communication without revealing personal phone numbers. Optional chat functionality is also available.",
  },
];

export default function BlaBlaItaly() {
  return (
    <>
      <BlaBlaHead data={HeadData} />
      <BlaBlaMission data={missionData} />

      <Suspense fallback={null}>
        <BlaBlaBusiness data={businessData} />
        <BlaBlaFeature data={featureData} />
        <BlaBlaTech data={techData} />
        <BlaBlaAction data={actionData} />
        <BlaBlaAllin data={allInData} />
        <BlaBlaMinimum data={minimumData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
